import { ecommerceInterface } from '@cbgms/api/modules/customers'
import { Box, Container, TextField } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
  container: {
    overflow: 'auto',
    height: '20.625rem',
    display: 'flex'
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  textField: {
    width: '100%'
  }
})

const ERPData: React.FC<{ erpData: ecommerceInterface }> = ({ erpData }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Container className={classes.container}>
      <Box className={classes.box}>
        <TextField
          label={t('PopUps.CustomerSegmentation')}
          type='input'
          variant='outlined'
          margin='normal'
          value={erpData.CustomerSegmentation || ''}
          InputProps={{ readOnly: true }}
          className={classes.textField}
          size='small'
        />
        <TextField
          label={t('PopUps.SalesRegion')}
          type='input'
          variant='outlined'
          margin='normal'
          value={erpData.SalesRegion || ''}
          InputProps={{ readOnly: true }}
          className={classes.textField}
          size='small'
        />
        <TextField
          label={t('PopUps.ABCIndicator')}
          type='input'
          variant='outlined'
          margin='normal'
          value={erpData.AbcIndicator || ''}
          InputProps={{ readOnly: true }}
          className={classes.textField}
          size='small'
        />
      </Box>
    </Container>
  )
}

export default ERPData
